export default "__VITE_ASSET__WGWVng9E__"